import { render, staticRenderFns } from "./DataPresentationSmall.vue?vue&type=template&id=a91f033a&scoped=true&"
import script from "./DataPresentationSmall.vue?vue&type=script&lang=js&"
export * from "./DataPresentationSmall.vue?vue&type=script&lang=js&"
import style0 from "./DataPresentationSmall.vue?vue&type=style&index=0&id=a91f033a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a91f033a",
  null
  
)

export default component.exports